import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })

export class RegexService {

    constructor() { }

    public nameRegex() {
        return /^[\s]*[a-zA-ZÀ-ÿ]+(([’'. -][a-zA-ZÀ-ÿ ])?[a-zA-ZÀ-ÿ]*)*[\s]*$/;
    }  

    public companyRegex() {
    
        return /^[\s]*[a-zA-ZÀ-ÿ]+(([\s]?[’'.&'-`. \s][a-zA-ZÀ-ÿ ])?[a-zA-ZÀ-ÿ]*)*[\s]*$/;
    }

    public emailRegex() {
        return "[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[.][A-Za-z]{2,63}?$";
    }
    
    public passwordRegex() {
        // return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&^()-_+={}~|])[A-Za-z\d$@$!%*#?&^()-_+={}~|]{8,}$/;
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&^()\-_+={}~|])[A-Za-z\d$@$!%*#?&^()\-_+={}~|]{8,}$/;
    }

}
